<script setup>
import { computed, defineProps } from "vue";
import { useUserStore } from "@/stores/user";
import { commonMarkToHtml, getInitials } from "@/utils/utils";

const props = defineProps({
  messageObj: {
    type: Object,
    required: true,
  },
  useMessageAuthor: {
    type: Boolean,
    default: false,
  },
});

// user info
const userStore = useUserStore();

const messageUser = computed(() => {
  if (!props.useMessageAuthor || !props.messageObj.user_id) {
    return userStore.user;
  }

  const name = props.messageObj.user_full_name || "Unknown User";
  return userStore.allDict[props.messageObj.user_id] || {
    name,
    shortName: getInitials(name),
  };
});

// frontend inserts transient user messages using blob url for the download, which
// can't be named.
const isBlob = (url) => url?.startsWith("blob:");
</script>

<template>
  <div class="user-message-container">
    <div style="{width: 3rem;}">
      <CircleCenter
        size="3em"
        :backgroundColor="'var(--primary-250)'"
        :borderColor="'var(--primary-250)'"
      >
        <span class="fs-5">{{ messageUser?.shortName || "NA" }}</span>
      </CircleCenter>
    </div>
    <div class="user-message-body-container message-body-container">
      <div class="user-message-title">
        <p>
          <span class="fw-bold">{{ messageUser?.name || "User" }}</span>
        </p>

        <!-- <p>Mar 31, 2025, 10:52:49 AM</p> -->
      </div>
      <p v-html="commonMarkToHtml(messageObj.response)"></p>
      <div
        v-if="messageObj.attachments.length"
        class="attachments-container mt-2"
      >
        <!-- TODO(J-H): Presigned URL for this comes from frontoffice. -->
        <a
          class="attachment"
          v-for="(attachmentObj, idx) in messageObj.attachments"
          :key="idx"
          :href="attachmentObj.url || '#'"
          :target="isBlob(attachmentObj.url) ? null : '_blank'"
          :download="isBlob(attachmentObj.url) ? attachmentObj.filename : null"
          ><span>{{ attachmentObj.filename }}</span></a
        >
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.attachments-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

.attachment {
  border: 1px solid #e6e6e6;
  padding: 0.25em 0.75em;
  border-radius: 10px;
  font-size: small;
  background-color: #e6e6e6;
  text-align: center;
  color: black;
  text-decoration: underline;
}

p {
  margin: 0;
}

.user-message-container {
  display: flex;
  gap: 1em;
}

.user-message-title {
  display: flex;
  gap: 0.5em;
  margin-bottom: 0.25em;
}
</style>
